// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgCopy12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M5.5.75A1.75 1.75 0 0 0 3.75 2.5h1.5a.25.25 0 0 1 .25-.25h3c.69 0 1.25.56 1.25 1.25v3a.25.25 0 0 1-.25.25v1.5a1.75 1.75 0 0 0 1.75-1.75v-3A2.75 2.75 0 0 0 8.5.75h-3ZM2.5 5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5Zm-2 .5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgCopy12;
